<!-- Entity Selection Dialog -->
<p-table
  #table
  [value]="fields"
  dataKey="field"
  styleClass="p-datatable-striped p-datatable-gridlines custom-overflow"
  jmlLibInitCallback
  (init)="afterTableInit()"
>
  <ng-template pTemplate="body" let-field>
    <tr [pSelectableRow]="rowData">
      <td class="w-6">
        <span class="flex align-items-center" style="min-height: 2.4rem">
          {{ field.header }}
        </span>
      </td>
      <td class="w-6" id="hoverEffect" style="position: relative" [ngSwitch]="field.type">
        <jml-lib-string-cell
          *ngSwitchCase="'String'"
          (completeCellEdit)="completeCellEdit($event)"
          [fieldName]="field.field"
          [rowData]="rowData"
          [editable]="field.editable"
          [mandatory]="field.mandatory"
        ></jml-lib-string-cell>
        <jml-lib-integer-cell
          *ngSwitchCase="'int'"
          (completeCellEdit)="completeCellEdit($event)"
          [fieldName]="field.field"
          [rowData]="rowData"
          [editable]="field.editable"
        ></jml-lib-integer-cell>
        <jml-lib-float-cell
          *ngSwitchCase="'float'"
          (completeCellEdit)="completeCellEdit($event)"
          [fieldName]="field.field"
          [rowData]="rowData"
          [editable]="field.editable"
          [decimals]="field.decimals"
        ></jml-lib-float-cell>
        <jml-lib-bool-cell
          *ngSwitchCase="'boolean'"
          (completeCellEdit)="completeCellEdit($event)"
          [fieldName]="field.field"
          [rowData]="rowData"
          [editable]="field.editable"
        ></jml-lib-bool-cell>
        <jml-lib-currency-cell
          *ngSwitchCase="'Currency'"
          (completeCellEdit)="completeCellEdit($event)"
          [fieldName]="field.field"
          [rowData]="rowData"
          [editable]="field.editable"
          [currency]="field.currency"
        ></jml-lib-currency-cell>
        <!--                <jml-lib-json-cell *ngSwitchCase="'json'" (completeCellEdit)="completeCellEdit($event)"-->
        <!--                    [header]="configuration.singleDisplayName + ' ' + data['_repr_'] + ' - ' + rowData.header"-->
        <!--                    [fieldName]="field.field" [rowData]="rowData" [editable]="field.editable"></jml-lib-json-cell>-->
        <!--                <jml-lib-python-cell *ngSwitchCase="'python'" (completeCellEdit)="completeCellEdit($event)"-->
        <!--                    [header]="configuration.singleDisplayName + ' ' + data['_repr_'] + ' - ' + rowData.header"-->
        <!--                    [fieldName]="field.field" [rowData]="rowData" [editable]="field.editable"></jml-lib-python-cell>-->
        <!--                <jml-lib-multiline-cell *ngSwitchCase="'Multiline'" (completeCellEdit)="completeCellEdit($event)"-->
        <!--                    [header]="configuration.singleDisplayName + ' ' + data['_repr_'] + ' - ' + rowData.header"-->
        <!--                    [fieldName]="field.field" [rowData]="rowData" [editable]="field.editable"-->
        <!--                    [mandatory]="field.mandatory"></jml-lib-multiline-cell>-->
        <jml-lib-icon-cell
          *ngSwitchCase="'Icon'"
          (completeCellEdit)="completeCellEdit($event)"
          [fieldName]="field.field"
          [rowData]="rowData"
          [editable]="field.editable"
          [header]="field.header"
          [catalogueHrid]="field.defaultCatalogue"
        ></jml-lib-icon-cell>
        <jml-lib-address-cell
          *ngSwitchCase="'Address'"
          (completeCellEdit)="completeCellEdit($event)"
          [fieldName]="field.field"
          [rowData]="rowData"
          [editable]="field.editable"
          [mandatory]="field.mandatory"
        ></jml-lib-address-cell>
        <jml-lib-date-period-cell
          *ngSwitchCase="'DatePeriod'"
          (completeCellEdit)="completeCellEdit($event)"
          [fieldName]="field.field"
          [rowData]="rowData"
          [editable]="field.editable"
          [mandatory]="field.mandatory"
        ></jml-lib-date-period-cell>
        <jml-lib-calendar-week-cell
          *ngSwitchCase="'CalendarWeek'"
          (completeCellEdit)="completeCellEdit($event)"
          [fieldName]="field.field"
          [rowData]="rowData"
          [editable]="field.editable"
        ></jml-lib-calendar-week-cell>
        <jml-lib-color-cell
          *ngSwitchCase="'Color'"
          (completeCellEdit)="completeCellEdit($event)"
          [fieldName]="field.field"
          [rowData]="rowData"
          [editable]="field.editable"
        ></jml-lib-color-cell>
        <jml-lib-icon-picker-cell
          *ngSwitchCase="'IconDefinition'"
          (completeCellEdit)="completeCellEdit($event)"
          [fieldName]="field.field"
          [rowData]="rowData"
          [editable]="field.editable"
        ></jml-lib-icon-picker-cell>
        <!--                <jml-lib-fsm-cell *ngSwitchCase="'State'" (completeCellEdit)="completeCellEdit($event)"-->
        <!--                    [fieldName]="field.field" [rowData]="rowData" [entityType]="configuration.type"-->
        <!--                    [editable]="field.editable"></jml-lib-fsm-cell>-->

        <jml-lib-dtotype-cell
          *ngSwitchCase="'dtoType'"
          [rowData]="rowData"
          [editable]="field.editable"
          [field]="field"
          (completeCellEdit)="updateField(field.field, $event.value)"
        ></jml-lib-dtotype-cell>

        <ng-container *ngSwitchDefault>
          <!--                    <jml-lib-entity-reference-cell *ngIf="_isEntityReference(rowData)"-->
          <!--                        (completeCellEdit)="completeCellEdit($event)" [fieldName]="field.field" [rowData]="rowData"-->
          <!--                        [field]="rowData" [editable]="field.editable" [dtoType]="configuration.type"-->
          <!--                        [mandatory]="rowData.mandatory"></jml-lib-entity-reference-cell>-->

          <jml-lib-drop-down-wrapper
            *ngIf="_isCatalogueEntry(field)"
            [rowData]="rowData"
            [editable]="field.editable"
            [field]="field"
            [entityId]="rowData.id"
            [dtoType]="dtoType"
            (completeCellEdit)="updateField(field.field, $event.value)"
          ></jml-lib-drop-down-wrapper>

          <jml-lib-date-cell
            *ngIf="field.type === 'Date' || field.type === 'DateTime'"
            (completeCellEdit)="completeCellEdit($event)"
            [fieldName]="field.field"
            [rowData]="rowData"
            [editable]="field.editable"
            [showTime]="rowData.type === 'DateTime'"
            [mandatory]="field.mandatory"
          >
          </jml-lib-date-cell>
        </ng-container>
      </td>
    </tr>
  </ng-template>
</p-table>
